import { ShopTypes, UmbracoTypes } from '~/lib/data-contract';
import useProduct from '~/services/shop/hooks/useProduct';
import usePage from '~/services/umbraco/hooks/usePage';

export default function useProductImages() {
    const { data: page } = usePage<UmbracoTypes.IP50ProductDetailPage>();

    const itemNo = decodeURIComponent(page?.pageProperties?.productItemNumber || '');
    return useProduct<ShopTypes.ProductQueryResource[]>(itemNo, (data) =>
        (data.product?.item?.images || []).concat(data.product?.images || []).filter(Boolean),
    );
}
